(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  let quiveOfferSizeObserver;

  const sizeQuiveOffer = () => {
    quiveOfferSizeObserver?.disconnect();
    const offer = document.querySelector('.quive-sitewide-offer');
    const utility = offer?.parentElement?.querySelector('.utility-bar');
    if (!offer || !utility) return;

    const setHeights = () => {
      document.documentElement.style.setProperty('--quive-offer-height', `${offer.offsetHeight}px`);
      document.documentElement.style.setProperty('--quive-utility-height', `${utility.offsetHeight}px`);
    };

    setHeights();
    if ('ResizeObserver' in window) {
      quiveOfferSizeObserver = new ResizeObserver(setHeights);
      quiveOfferSizeObserver.observe(offer);
      quiveOfferSizeObserver.observe(utility);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sizeQuiveOffer, { once: true });
  } else {
    sizeQuiveOffer();
  }

  document.addEventListener('shopify:section:load', sizeQuiveOffer);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !window.matchMedia('(max-width: 989px)').matches) return;
    const summary = event.target.closest('header-drawer > details > summary');
    if (!summary || summary.parentElement.hasAttribute('open')) return;
    const offerSection = document.querySelector('.quive-sitewide-offer')?.closest('.announcement-bar-section');
    const header = document.querySelector('.section-header');
    if (!offerSection || !header) return;
    document.documentElement.style.setProperty('--quive-menu-announcement-top', `${offerSection.getBoundingClientRect().top}px`);
    document.documentElement.style.setProperty('--quive-menu-header-top', `${header.getBoundingClientRect().top}px`);
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.quive-announcement-mobile .slider-button');
    if (!button) return;
    button.closest('.quive-announcement-mobile')?.classList.add('quive-announcement-manual');
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' || !(event.target instanceof Element)) return;
    const slider = event.target.closest('.quive-announcement-mobile .slider');
    const carousel = slider?.closest('slideshow-component');
    if (!carousel) return;
    carousel.pause();
    carousel.classList.add('quive-announcement-manual');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qp-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialiseCoutureHome = () => {
    const main = document.querySelector('#MainContent[data-template="index"]');
    if (!main) return;

    const revealItems = main.querySelectorAll(
      '.collection__title, .collection .grid__item, .qp-featured-collections .qp-section-heading, .qp-collection-card, .qp-best-sellers__header, .qp-product-card, .image-with-text__media, .image-with-text__content'
    );

    if (!reduceMotion.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, activeObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          activeObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      revealItems.forEach((item, index) => {
        if (item.dataset.quiveRevealReady === 'true') return;
        item.dataset.quiveRevealReady = 'true';
        item.classList.add('quive-reveal');
        item.style.setProperty('--quive-delay', `${(index % 4) * 85}ms`);
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    main.querySelectorAll('.qp-collection-card').forEach((card) => {
      if (card.dataset.quiveSpotlightReady === 'true' || reduceMotion.matches) return;
      card.dataset.quiveSpotlightReady = 'true';
      card.classList.add('quive-spotlight');
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--spot-x', `${event.clientX - rect.left}px`);
        card.style.setProperty('--spot-y', `${event.clientY - rect.top}px`);
      });
    });

    const heroMedia = main.querySelector('[data-quive-hero-media]');
    if (heroMedia && heroMedia.dataset.quiveParallaxReady !== 'true' && !reduceMotion.matches) {
      heroMedia.dataset.quiveParallaxReady = 'true';
      heroMedia.addEventListener('pointermove', (event) => {
        const rect = heroMedia.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 12;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * 12;
        heroMedia.style.setProperty('--hero-x', `${x}px`);
        heroMedia.style.setProperty('--hero-y', `${y}px`);
        heroMedia.style.setProperty('--hero-rx', `${(-y * 0.06).toFixed(2)}deg`);
        heroMedia.style.setProperty('--hero-ry', `${(x * 0.06).toFixed(2)}deg`);
      });
      heroMedia.addEventListener('pointerleave', () => {
        heroMedia.style.setProperty('--hero-x', '0px');
        heroMedia.style.setProperty('--hero-y', '0px');
        heroMedia.style.setProperty('--hero-rx', '0deg');
        heroMedia.style.setProperty('--hero-ry', '0deg');
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCoutureHome, { once: true });
  } else {
    initialiseCoutureHome();
  }

  document.addEventListener('shopify:section:load', initialiseCoutureHome);
})();

  } catch(e) { console.error(e); }
})();
})();
